module.exports = __webpack_public_path__ + "static/media/BulkReturn4.0e32bb24.png";